import jwt from 'jwt-decode';

export const getTokenData = (token: string) => {
  const decodedToken = jwt(token) as {
    is_global_admin: boolean;
    sub: string;
    exp: number;
  };
  const isGlobalAdmin: boolean = decodedToken.is_global_admin;
  const username: string = decodedToken.sub;
  const expirationTimestamp: number = decodedToken.exp;

  return { isGlobalAdmin, username, expirationTimestamp };
};
